import { render } from "./deliveryShedule_old.vue?vue&type=template&id=8ebb32c0&scoped=true"
import script from "./deliveryShedule_old.vue?vue&type=script&lang=js"
export * from "./deliveryShedule_old.vue?vue&type=script&lang=js"

import "./deliveryShedule_old.vue?vue&type=style&index=0&id=8ebb32c0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ebb32c0"]])

export default __exports__